import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

const routes: Routes = [
  {
    path: 'devices/:deviceId',
    redirectTo: 'devices/:deviceId/versions',
  },
  {
    path: '**',
    pathMatch: 'full',
    redirectTo: 'devices',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
